import styled from "styled-components";
import DesignConstants from "../../../constants/DesignConstants";
import PhaseSixIcon from "../../../basic/phaseSixIcon/PhaseSixIcon";

export const Wrapper = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: ${DesignConstants.SPACES.S} 0;
    background: ${DesignConstants.COLORS.BACKGROUND_LIGHT};
    width: calc(100vw - ${DesignConstants.SPACES.L});
    max-width: calc(${process.env.REACT_APP_UPPER_GRID_STEP_BORDER}px - 2rem);
    margin: auto;
    gap: ${DesignConstants.SPACES.S};
`;

export const ScrollToTopButton = styled.div`
    display: flex;
    margin-right: ${DesignConstants.SPACES.S};
    align-self: flex-end;
    z-index: 100;
    width: ${DesignConstants.SIZES.ICON_M};
    height: ${DesignConstants.SIZES.ICON_M};
    background: white;
    border-radius: 50%;
    border: ${DesignConstants.BORDERS.THIN_GREY};
    cursor: pointer;
    pointer-events: auto;

    align-items: center;
    justify-content: center;
`;

export const StyledP6Icon = styled(PhaseSixIcon)`
    font-size: ${DesignConstants.FONT_SIZES.XXL};
    color: ${DesignConstants.COLORS.MID_GREY};
`;

export const PositioningWrapper = styled.div`
    display: flex;
    position: absolute;
    top: calc(-${DesignConstants.SIZES.ICON_M} + ${DesignConstants.SPACES.XS});
    width: 100%;
    overflow: visible;
    justify-content: center;
    align-items: center;
    pointer-events: none;
`;

export const FullWidthWrapper = styled.div`
    position: absolute;
    display: flex;
    width: 100vw;
    max-width: 1400px;
    justify-content: flex-end;
    pointer-events: none;
`;

export const OuterWrapper = styled.div<{ $isSticky?: boolean }>`
    display: flex;
    /* sticky keeps the footer in normal flow so content is never hidden behind it; fixed (default)
       preserves the original overlay behaviour for the other create steps */
    position: ${(props) => (props.$isSticky ? "sticky" : "fixed")};
    align-items: flex-start;
    bottom: 0;
    z-index: 10;

    /* in sticky mode, push the footer to the bottom of the flex-column page wrapper */
    ${(props) => props.$isSticky && "margin-top: auto;"}
`;
